module.exports = __webpack_public_path__ + "static/media/calendar.dca9feac.e927be3f.png";